import NextLink, { LinkProps } from 'next/link';
import { forwardRef } from 'react';

type Props = LinkProps & React.AnchorHTMLAttributes<HTMLAnchorElement>;

const CustomLink = forwardRef<HTMLAnchorElement, Props>(function CustomLink(
  { prefetch = false, ...props },
  ref
) {
  // TODO: Without app router it will not work, use NoHoverPrefetchAnchorProps as for now.
  return <NextLink prefetch={prefetch} ref={ref} {...props} />;
});

export default CustomLink;
